import React from 'react';
import {useTranslation} from "react-i18next";

const ApplyBtn = ({btnName, onClick, classBtn}) => {
    return (
        <button className={`btn-apply ${classBtn ? classBtn : ""}`} onClick={onClick}>{btnName}</button>
    );
};

export default ApplyBtn;